import { ITEM_TYPES } from 'constants/itemType';
import { NotificationPriority } from 'hooks/useNotification';
import type { UserNotificationWithDetails } from 'hooks/useUserNotifications';

/** Stable id for the hardcoded FEMA Thunderbolt workspace invitation. */
export const FEMA_THUNDERBOLT_INVITE_NOTIFICATION_ID =
  'demo-fema-thunderbolt-workspace-invite';

const FEMA_THUNDERBOLT_INVITE_SENT_AT = '2026-09-30T15:00:00.000Z';

export const FEMA_THUNDERBOLT_INVITE_MESSAGE =
  "You've been invited to join the workspace for FEMA Thunderbolt Exercise.";

export function isHardcodedFemaThunderboltInvite(
  notificationId: string | null | undefined
): boolean {
  return notificationId === FEMA_THUNDERBOLT_INVITE_NOTIFICATION_ID;
}

export function getFemaThunderboltInviteNotification(
  groupId: string
): UserNotificationWithDetails {
  return {
    userGuid: 'system',
    notificationId: FEMA_THUNDERBOLT_INVITE_NOTIFICATION_ID,
    groupId,
    archived: false,
    acknowledged: false,
    canArchive: false,
    createdAt: FEMA_THUNDERBOLT_INVITE_SENT_AT,
    acknowledgedAt: null,
    archivedAt: null,
    priority: NotificationPriority.INFO,
    status: 'sent',
    acknowledgementRequired: false,
    sourceItemId: '',
    sourceItemType: ITEM_TYPES.Sitrep,
    sentAt: FEMA_THUNDERBOLT_INVITE_SENT_AT,
    scheduledDate: null,
    incidentId: null,
    aors: [],
    appMessage: FEMA_THUNDERBOLT_INVITE_MESSAGE,
    emailSubject: null,
    emailMessage: null,
    smsMessage: null,
    teamsMessage: null,
    sendEmail: null,
    sendSms: null,
    sendTeams: null,
    actionType: null,
    createdByName: 'FEMA',
  };
}
